import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type IconToggleProps = {
  readonly active: boolean;
  readonly onToggle: (active: boolean) => void;
  readonly disabled?: boolean;
  readonly className?: string;
  readonly activeColorClassName?: string;
  readonly inactiveColorClassName?: string;
  readonly iconClassName: string;
  readonly testId: string;
  readonly tooltip: string;
};

export const IconToggle: FC<IconToggleProps> = ({
  active,
  onToggle,
  disabled = false,
  className,
  activeColorClassName = 'bg-tweaked-brand text-white',
  inactiveColorClassName = 'bg-white text-tweaked-brand',
  iconClassName,
  testId,
  tooltip,
}) => {
  const colorClassNames = active
    ? activeColorClassName
    : inactiveColorClassName;
  const disabledClassNames = disabled ? 'text-white bg-light-grey' : '';

  return (
    // Button has a title attribute & visual icon
    // eslint-disable-next-line jsx-a11y-x/control-has-associated-label
    <button
      data-testid={testId}
      type="button"
      disabled={disabled}
      className={twMerge(
        'h-[26px] w-[26px]',
        'flex items-center justify-center',
        'rounded-sm border border-gray-300 disabled:cursor-default',
        colorClassNames,
        disabledClassNames,
        className,
      )}
      onClick={() => onToggle(!active)}
      aria-pressed={active}
      title={tooltip}
    >
      <i
        aria-hidden
        className={twMerge('text-xl', iconClassName)}
        // our icon library's css file adds margins with ::before pseudo element and this inline style is hack to get rid of those
        style={{ marginLeft: '-0.2em', marginRight: '-0.2em' }}
      />
    </button>
  );
};
